import axios from '@axios'

const reportEndpointMap = {
    warehouse_stock_movements: 'reports/warehouse_stock_movements',
    tf_summary: 'reports/tf_summary',
    tf_detail_by_tf_number: 'reports/tf_detail_by_tf_number',
    bales_undelivered_by_transporter: 'reports/bales_undelivered_by_transporter',
    tf_in_transit: 'reports/tf_in_transit_details',
    tf_in_que: 'reports/tf_in_queue',
    tobacco_transported_to_green_receiving: 'reports/tobacco_transported_to_green_receiving',
}

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        locations: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('locations', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        warehouses: (cntx, params) => new Promise((resolve, reject) => {
            axios.get('warehouse_names', { params })
                .then(response => resolve(response))
                .catch(error => reject(error))
        }),
        report: (cntx, params) => {
            const { reportType, ...requestParams } = params || {}
            const endpoint = reportEndpointMap[reportType] || reportEndpointMap.warehouse_stock_movements
            console.log('StockProduction report fetch:', {
                reportType,
                endpoint,
                requestParams,
            })

            return new Promise((resolve, reject) => {
                axios.get(endpoint, { params: requestParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    },
}
